import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=18279ba6&scoped=true&"
import script from "./Loading.vue?vue&type=script&lang=ts&"
export * from "./Loading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18279ba6",
  null
  
)

export default component.exports